export const SET_VENDOREVENTS = "SET_VENDOREVENTS";
export const GET_VENDOREVENTS = "GET_VENDOREVENTS";
